import React, { useState } from "react";
import "./CartModal.css";
import { globals } from '../globals';

function Checkout({ total, onClose, cartItems }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const orderList = cartItems
      .map(item => `- ${item.alt} (${item.filename}) - €${item.price?.toFixed(2)}`)
      .join("\n");
  
    try {
          // Salva ordine nel DB
        await fetch(`${globals.homepageUrl}/php/save-order.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          cart: cartItems,
          total: total,
          email: email,
        }),
      });

      const res = await fetch(globals.homepageUrl+"/php/send-order.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          order: orderList,
          total: `€${total.toFixed(2)}`
        }),
      });
  
      const json = await res.json();
  
      if (json.success) {
        setSent(true);
        localStorage.removeItem("cart");
        window.dispatchEvent(new Event("cartUpdated"));
        window.dispatchEvent(new Event("ordersUpdated"));
        setTimeout(() => {
          onClose(); // chiude dopo 3 secondi
        }, 3000);
      } else {
        alert("Errore: " + (json.error || "Impossibile inviare email"));
      }
    } catch (err) {
      alert("Errore connessione col server.");
    }
  };
  

  return (
    <div className="cart-modal-overlay" onClick={onClose}>
      <div className="cart-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Checkout</h2>
        <p>Totale da pagare: €{total.toFixed(2)}</p>
  
        {sent ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              height: "80px",
              backgroundColor: "#dff0d8",
              color: "#3c763d",
              borderRadius: "8px",
              fontWeight: "bold",
              marginTop: "30px",
              textAlign: "center",
              padding: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            ✅ Ordine inviato con successo!
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Inserisci la tua email"
              required
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                marginBottom: "10px",
              }}
            />
            <div style={{ display: "grid", justifyContent: "center" }}>
              <button
                type="submit"
                style={{
                  backgroundColor: "#28a745",
                  color: "#fff",
                  width: "100%",
                  padding: "10px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Invia ordine
              </button>
              <button
                type="button"
                onClick={onClose}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "#ccc",
                  border: "none",
                  borderRadius: "5px",
                }}
              >
                Annulla
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
  }

export default Checkout;
